import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
// https://doc2.ixiaochuan.cn/display/zdxm/3.22.0

// 冷启动状态获取
const VirtualStatus: {
  // 是否展示切换按钮
  show?: boolean
  // -1答题不及格 0未答题 1答题及格
  answer?: -1 | 0 | 1
  // true已领取， false未领取
  had_question_dress?: boolean
  // 分数
  score?: number
} = {}
// doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41427043
export const h5_stat = createAsyncThunk(
  '/live/dress/h5_stat',
  async (answer, store) => {
    const resp = await http.post<HiyaRes<typeof VirtualStatus>>(
      '/live/dress/h5_stat',
      store.getState().env.deviceinfo
    )
    return resp.data.data
  }
)

// 冷启答题
const VirtualStart: {
  dress_coins?: number
  dress_days?: number
  dress_img?: string
  // 问题
  list: Array<{
    idx: string
    question: string
    options: Array<{
      idx: string
      content: string
      score: number
    }>
    // 1单选题，2多选题
    type: 1 | 2
  }>
  video?: string
} = {
  list: [],
}
export const question_list = createAsyncThunk(
  '/live/dress/question_list',
  async (arg, store) => {
    const resp = await http.post<HiyaRes<typeof VirtualStart>>(
      '/live/dress/question_list',
      store.getState().env.deviceinfo
    )
    return resp.data.data
  }
)
// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41420788
export const submit_answert = createAsyncThunk(
  '/live/dress/submit_answer',
  async (answer: any, store) => {
    const resp = await http.post<
      HiyaRes<{
        pass: boolean
        score: number
      }>
    >('/live/dress/submit_answer', {
      ...store.getState().env.deviceinfo,
      answer,
    })
    return resp.data.data
  }
)

// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41426858
export const switch_dress_ver = createAsyncThunk(
  '/live/dress/switch_dress_ver',
  async (operation: 1 | 2, store) => {
    const resp = await http.post<HiyaRes<any>>('/live/dress/switch_dress_ver', {
      ...store.getState().env.deviceinfo,
      operation,
    })
    return resp.data.data
  }
)
// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41427774
export const white_mid_send_dress = createAsyncThunk(
  '/live/dress/white_mid_send_dress',
  async (arg, store) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/dress/white_mid_send_dress',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
// 反馈
// doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35751537
const VirtualFeedback: {
  parent_reason?: number
  list?: Array<{
    id: number
    title: string
  }>
} = {}
export const feedback_options = createAsyncThunk(
  '/live/misc/feedback_options',
  async (arg, store) => {
    const resp = await http.post<HiyaRes<typeof VirtualFeedback>>(
      '/live/misc/feedback_options',
      {
        ...store.getState().env.deviceinfo,
        from: 'dress',
      }
    )
    return resp.data.data
  }
)
// 提交反馈
export const feedback = createAsyncThunk(
  '/live/misc/feedback',
  async (
    arg: {
      reason: number
      text: string
      image_data: string[]
    },
    store
  ) => {
    const {
      env: {deviceinfo},
      Virtual: {
        VirtualFeedback: {parent_reason},
      },
    } = store.getState()
    const resp = await http.post<HiyaRes<typeof VirtualFeedback>>(
      '/live/misc/feedback',
      {
        ...arg,
        mid: deviceinfo.h_m,
        app_version: deviceinfo.h_app,
        device_model: deviceinfo.h_model,
        parent_reason,
      }
    )
    return resp.data.data
  }
)
// 任务
export type JobsType = Array<{
  job_id: number
  jump_url: string
  status: number
  job_icon: string
  desc: string
  reward: number
  is_close: boolean
}>
const VirtualTask: {
  TipList?: Array<{
    id: number
    mid: number
    nick_name: string
    prize_name: string
    ct: string
  }>
  avatar?: string
  diamonds_left?: number
  pre_lottery_cost?: number
  daily_jobs?: JobsType
  improvement_jobs?: JobsType
  lottery_list?: Array<{
    prize_id: number
    img_url: string
    name: string
  }>
} = {}
// 初始化信息: 奖品列表、日常/特殊任务列表、剩余宝石数量、单次抽奖消耗
export const VirtualTaskInfo = createAsyncThunk(
  '/live/dress/mission_center',
  async (arg, store) => {
    const resp = await http.post<HiyaRes<Omit<typeof VirtualTask, 'TipList'>>>(
      '/live/dress/mission_center',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
// 中奖纪录
export const VirtualTaskTipList = createAsyncThunk(
  '/live/dress/mission_lottery_log',
  async (arg, store) => {
    const resp = await http.post<
      HiyaRes<{
        list: typeof VirtualTask['TipList']
      }>
    >('/live/dress/mission_lottery_log', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 点击抽奖获取抽奖结果
export const VirtualTaskLottery = createAsyncThunk(
  '/live/dress/mission_lottery',
  async (arg, store) => {
    const resp = await http.post<
      HiyaRes<{
        err_msg: string
        status: number
        prize_id: number
        prize_show_img: string
        diamonds_left: number
        prize_name: string
      }>
    >('/live/dress/mission_lottery', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
// 任务奖励领取
export const VirtualTaskAward = createAsyncThunk(
  '/live/dress/mission_award',
  async (job_id: number, store) => {
    const resp = await http.post<
      HiyaRes<{
        list: typeof VirtualTask['TipList']
      }>
    >('/live/dress/mission_award', {
      ...store.getState().env.deviceinfo,
      job_id,
    })
    return resp.data.data
  }
)
const initialState = {
  VirtualStatus,
  VirtualStart,
  VirtualFeedback,
  VirtualTask,
}

export const VirtualSlice = createSlice({
  name: 'Virtual',
  initialState,
  reducers: {
    toAnswer: (state) => {
      Object.assign(state, {
        VirtualStatus: {
          ...state.VirtualStatus,
          answer: 0,
        },
      })
    },
    setDimondsLeft: (state, action) => {
      Object.assign(state, {
        VirtualTask: {
          ...state.VirtualTask,
          diamonds_left: action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(h5_stat.fulfilled, (state, action) => {
      Object.assign(state, {
        VirtualStatus: action.payload,
      })
    })
    builder.addCase(question_list.fulfilled, (state, action) => {
      Object.assign(state, {
        VirtualStart: {
          ...state.VirtualStart,
          ...action.payload,
        },
      })
    })
    builder.addCase(submit_answert.fulfilled, (state, action) => {
      Object.assign(state, {
        VirtualStatus: {
          ...state.VirtualStatus,
          answer: action.payload.pass ? 1 : -1,
          score: action.payload.score,
        },
      })
    })
    // 反馈
    builder.addCase(feedback_options.fulfilled, (state, action) => {
      Object.assign(state, {
        VirtualFeedback: action.payload,
      })
    })
    // 任务
    builder.addCase(VirtualTaskInfo.fulfilled, (state, action) => {
      Object.assign(state.VirtualTask, {
        ...state.VirtualTask,
        ...action.payload,
      })
    })
    builder.addCase(VirtualTaskTipList.fulfilled, (state, action) => {
      Object.assign(state.VirtualTask, {
        ...state.VirtualTask,
        TipList: action.payload.list,
      })
    })
  },
})
export const VirtualSliceActions = VirtualSlice.actions
export default VirtualSlice.reducer
export const useVirtualState = () => {
  const data = useSelector((state) => state.Virtual)
  return data
}
